import axios from 'axios';

export const publicApi = axios.create({
  baseURL: 'https://mtarx.org/api',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
});

const api = axios.create({
  baseURL: 'https://mtarx.org/api',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
